import React from "react";
import Hero from "../components/Hero/Hero";
import OurApproach from "../components/OurApproach/OurApproach";
import About from "../components/AboutSection/About";
import Category from "../components/Category/Category";
import WhyChooseUs from "../components/WhyChooseUs/WhyChooseUs";
import OurCourses from "../components/OurCourses/OurCourses";
import Contact from "../components/ContactSection/Contact";
import FaqSection from "../components/FaqSection/FaqSection";

const Home = () => {
  return (
    <>
      <Hero />
      <OurApproach />
      <About />
      <WhyChooseUs />
      <Category />
      <OurCourses />
      <FaqSection />
      <Contact />
    </>
  );
};

export default Home;
